{
  "it": {
    "upload": {
      "labels": {
        "cancelUpload": "Annulla caricamento",
        "cancelUploadConfirmation": "È sicuro di voler annullare questo caricamento?",
        "chooseCategory": "Faccia clic per selezionare prima una categoria",
        "defaultMessage": "Aggiunga o trascini i file",
        "fallbackMessage": "Il browser in uso non supporta il caricamento dei file tramite trascinamento.",
        "fallbackText": "Utilizzi il modulo alternativo qui sotto per caricare i file come si faceva una volta.",
        "fileTooBig": "Il file è troppo grande ({filesize} MB). Dimensione massima: {maxFilesize} MB.",
        "invalidFileType": "Non è possibile caricare file di questo tipo.",
        "maxFilesExceeded": "Non è possibile caricare altri file.",
        "noExtension": "Il file non ha estensione",
        "rejectedFiles": "I seguenti file sono stati rifiutati:",
        "removeFile": "Rimuovi file",
        "responseError": "Il server ha risposto con il codice {statusCode}.",
        "uploadConfirmation": "Caricamento confermato",
        "uploadError": "Errore di caricamento",
        "warningMaxFileSize": "Fino a {max_files_size} ciascuno"
      }
    }
  }
}
